import React from "react";

const DeleteButton = ({ children, formButton, onPress, style }) => {
  if (formButton) {
    return (
      <button type={"submit"} className="deal-delete-button" style={style}>
        {children}
      </button>
    );
  }

  return (
    <button
      className="deal-delete-button"
      style={style}
      type={"button"}
      onClick={onPress}
    >
      {children}
    </button>
  );
};

export { DeleteButton };
